import { memo, useMemo } from "react";
import { Table } from "reactstrap";

const ListOfInvoice = ({ invoices, setInvoices, setFieldValue }) => {

    const handlepayment = (e) => {
        const { id, value } = e.target;

        const updatedInvoices = invoices.map(invoice => {
            if (invoice?.id === Number(id)) {
                invoice.paymentAboutToPay = Number(value || 0);
            }
            return invoice;
        });

        // Calculate the total payment amount
        const totalPaymentAmount = updatedInvoices.reduce((total, item) => {
            return total + (item.paymentAboutToPay || 0);
        }, 0);

        // Update payment_amount field in form values
        setFieldValue('payment_amount', totalPaymentAmount);
        setInvoices(updatedInvoices);
    };

    return (
        <div className="table-responsive">
            <Table className="table mb-0">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Invoice Number</th>
                        <th>Bill Amount</th>
                        <th>Due Amount</th>
                        <th>Payment</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        invoices?.map((item) => {
                            return (
                                <tr key={item?.id}>
                                    <th>{item?.invoice_date}</th>
                                    <td>{item?.v_invoice_id}</td>
                                    <td> {item?.grand_total || 0}</td>
                                    <td>
                                        <div className=" d-flex justify-content-start items-center ">
                                            <span>
                                                {parseFloat(item?.due_amount) || parseFloat(item?.grand_total)}
                                            </span>
                                            <div role="button"
                                                onClick={() => {
                                                    let e = { target: { name: 'paymentAboutToPay', id: item?.id, value: parseFloat(item?.due_amount) || parseFloat(item?.grand_total) } }
                                                    handlepayment(e)
                                                }}
                                                className="btn p-0 text-primary">
                                                ( Pay Full )
                                            </div>
                                        </div>
                                    </td>
                                    <td> <input
                                        className="form-control text-end"
                                        id={item?.id}
                                        autoComplete={false}
                                        name='paymentAboutToPay'
                                        onChange={(e) => {
                                            if (/^[0-9]*$/.test(e.target?.value)) {
                                                handlepayment(e)
                                            }
                                        }}
                                        value={item?.paymentAboutToPay || ''}
                                        type="text" /></td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </Table>
        </div>
    )
}

export default memo(ListOfInvoice);